// Module
var code = "<div data-bind=\"text: content\"></div>\r\n";
// Exports
module.exports = code;